import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import Tooltip from 'components/tooltip';

export default function VoucherEditorTableTH({
  children,
  className,
  numeric,
  required,
  sticky,
  width,
  withTooltip,
  ...props
}) {
  const thClass = classNames(className, {
    double: width === 2,
    triple: width === 3,
    required,
    'text-end': numeric,
    'end-cell sticky-cell': sticky,
  });

  let content = children;

  if (withTooltip) {
    const ref = React.createRef();
    content = (
      <Tooltip
        childrenRef={ref}
        content={children}
        onlyOnOverflow
        placement="bottom"
      >
        <span ref={ref}>{children}</span>
      </Tooltip>
    );
  }

  return (
    <th className={thClass} {...props}>
      {content}
    </th>
  );
}

VoucherEditorTableTH.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  numeric: PropTypes.bool,
  required: PropTypes.bool,
  width: PropTypes.oneOf([1, 2, 3]),
  withTooltip: PropTypes.bool,
};
